define(
({
  "select_shipping_method": "Seleziona indirizzo di spedizione"
})
);
